import { render, staticRenderFns } from "./DeviceMetaTab.vue?vue&type=template&id=52e67e1c"
import script from "./DeviceMetaTab.vue?vue&type=script&lang=js"
export * from "./DeviceMetaTab.vue?vue&type=script&lang=js"
import style0 from "./DeviceMetaTab.vue?vue&type=style&index=0&id=52e67e1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports